import React from 'react'
import { cdnImg } from 'meinian-package/src/utils/image'
import Icon from 'meinian-package/src/component/icon'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import CollectGroupBtn from '../../../../../component/collectGroupBtn'
import Uninterested from '../cardUninterestedAction'
import styles from './index.module.less'

export default (props) => { // 款式卡片
  const { columnWidth, mainUrl, itemId, item, onDeleteItem, onUninterested, onClickCard } = props

  const type = {
    [PLATFORM_VALUE.INS]: {
      className: 'intellect-footer-icon-bg-ins',
      icon: 'm-INS'
    },
    [PLATFORM_VALUE.XIAOHONGSHU]: {
      className: 'intellect-footer-icon-bg-xhs',
      icon: 'm-xiaohongshu'
    },
    [PLATFORM_VALUE.ITEM]: {
      className: 'intellect-footer-icon-bg-item',
      icon: 'm-taobao'
    }
  }

  const sourceEnum = {
    [PLATFORM_VALUE.ITEM]: {
      label: '淘宝商品',
      name: item.itemDataDTO?.shopName,
      linkDetailUrl: `/itemDetail/overview?itemId=${item.itemDataDTO?.itemId}`,
      linkTitleUrl: `/shopDetail?shopId=${item.itemDataDTO?.shopId}`,
      info: item.itemDataDTO
    },
    [PLATFORM_VALUE.INS]: {
      label: 'Instagram',
      name: item.insDataDTO?.bloggerName,
      linkDetailUrl: `/df/detail/image?blogIds=${item.imageGroupEntityId}&unionIds=${item.unionId}&platformId=${item.platformId}`,
      linkTitleUrl: `/df/detail/blogger?sourceType=1&id=${item.insDataDTO?.bloggerId}`,
      info: item.insDataDTO
    },
    [PLATFORM_VALUE.XIAOHONGSHU]: {
      label: '小红书',
      name: item.xhsDataDTO?.bloggerName,
      linkDetailUrl: `/df/detail/image?blogIds=${item.imageGroupEntityId}&unionIds=${item.unionId}&platformId=${item.platformId}`,
      linkTitleUrl: `/df/detail/blogger?sourceType=5&id=${item.xhsDataDTO?.bloggerId}`,
      info: item.xhsDataDTO,
    }
  }
  return <div style={{ width: columnWidth, height: Math.round((columnWidth * props.height) / props.width) }} className={styles['intellect-card-style']}>
    <div
      className="intellect-card-content"
      onClick={(e) => {
        if (onClickCard) {
          onClickCard?.(item, e)
        } else {
          const url = sourceEnum?.[item.platformId]?.linkDetailUrl
          if (url) {
            window.open(url)
          }
        }
      }}
    >
      <div className="intellect-card-hover">
        <div className="hover-collect">
          <CollectGroupBtn currentBlog={props} afterJoin={props.initSubColls} />
        </div>
        <Uninterested
          itemId={itemId}
          className="intellect-card-uninterested"
          onChange={() => {
            onDeleteItem(item)
            onUninterested(item)
            props?.onResize?.()
          }}
        />
      </div>
      <div className="intellect-footer">
        <div className={type?.[item.platformId]?.className}>
          <Icon type={type?.[item.platformId]?.icon} className="intellect-footer-icon" />
        </div>
        {
          sourceEnum?.[item.platformId]?.name && <div className="intellect-footer-info">
            <div
              style={{ width: columnWidth - 24 - 40 - 8 }}
              className="text-overflow intellect-footer-info-link"
              onClick={(e) => {
                e.stopPropagation()
                const url = sourceEnum?.[item.platformId]?.linkTitleUrl
                if (url) {
                  window.open(url)
                }
              }}
            >{sourceEnum?.[item.platformId]?.name}</div>
            <div>来自{sourceEnum?.[item.platformId]?.label}</div>
          </div>
        }
      </div>
      <img
        loading="lazy"
        src={cdnImg(mainUrl, 500)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }}
      />
    </div>
  </div>
}
